import { calculateDaysPast } from 'spa/shared/utils'
import { FormattedDate, FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles.sass'

Badge.propTypes = {
  createdOn: PropTypes.string.isRequired,
  updatedOn: PropTypes.string.isRequired,
}

export function Badge({ createdOn, updatedOn }) {
  const wasCreated = calculateDaysPast(Date.parse(createdOn)) <= 15
  const wasUpdated = calculateDaysPast(Date.parse(updatedOn)) <= 15
  if (wasCreated) {
    return (
      <div className={styles.pin}>
        <FormattedMessage defaultMessage="New" id="djcity.records.pin.new" />
      </div>
    )
  }
  if (!wasCreated && wasUpdated) {
    return (
      <div className={styles.pin}>
        <FormattedMessage
          defaultMessage="Updated"
          id="djcity.records.pin.updated"
        />
        <FormattedDate
          day="2-digit"
          month="numeric"
          value={new Date(updatedOn)}
        />
      </div>
    )
  }
  return null
}
